export default function getColor(e) {
    return this.$vuetify.theme.themes.light.primary + '55';
}